import React, {useEffect, useState} from 'react';
import Section from "../../components/section";
import HelperService from "../../services/helper-service";
import MainLayout from "../../layouts/main";
import {useGlobalNotificationMessage} from "../../context/message";
import {useBuildingService} from "../../services/building-service";
import InitialLoading from "../../components/initial-loading";
import BuildingPortfolioCard from "../../components/buildings/building-portfolio-card";
import PageTitle from "../../components/page-title";
import BuildingPortfolioRow from "../../components/buildings/building-portfolio-row";
import BuildingPortfolioScrolling from "../../components/buildings/building-portfolio-scrolling";
import {getPersistedDisplayUsers} from "../../utils/auth";
import {AppEvents} from "../../utils/constants";
import {useEventsService} from "../../services/events-service";

export default function BuildingsPortfolio () {
  const buildingService = useBuildingService();
  const eventsService = useEventsService();

  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const [buildings, setBuildings] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [mode, setMode] = useState('grid');
  const [displayUsers, setDisplayUsers] = useState(getPersistedDisplayUsers());

  useEffect(() => {
    eventsService.on(AppEvents.displayUsersChanged, (event) => {
      setDisplayUsers(getPersistedDisplayUsers());
    })
  }, []);

  useEffect(()=>{
   reloadPortfolio();
  }, [displayUsers]);

  function reloadPortfolio(){
    buildingService.getPortfolio()
      .then((rows)=>{
        setBuildings(rows.map(b=>{
          return b;
        }));
        setLoaded(true);
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa získať dáta.");
      })
  }

  return (
    <>

      {!loaded && <InitialLoading />}

      {loaded && <Section animation={HelperService.getRandomAnimation()}>
        <div className="container">
          <div className="row">

            <div className="d-flex align-items-center justify-content-between mb-2">
              <PageTitle>Portfólio nehnuteľností</PageTitle>
              <div className="btn-group" role="group" aria-label="Typ zobrazenia">
                <button type="button" className={`btn btn-outline-primary ${mode==='grid'?'active':''}`} onClick={()=>setMode('grid')}><span className={"mdi mdi-grid"}></span></button>
                <button type="button" className={`btn btn-outline-primary ${mode==='table'?'active':''}`} onClick={()=>setMode('table')}><span className={"mdi mdi-format-align-justify"}></span></button>
                <button type="button" className={`btn btn-outline-primary ${mode==='scrolling'?'active':''}`} onClick={()=>setMode('scrolling')}><span className={"mdi mdi-format-horizontal-align-right"}></span></button>
              </div>
            </div>

            {!buildings.length>0 && <div className="col-12">
              <div className="card">
                <div className="card-body text-center">
                  <p>Zatiaľ prázdne :(</p>
                </div>
              </div>
            </div>}

            {buildings.length>0 && mode==='grid' && buildings.map((building)=><BuildingPortfolioCard key={`building-grid-${building.id}`} building={building} />)}

            {buildings.length>0 && mode==='table' && buildings.map((building)=><BuildingPortfolioRow key={`building-table-${building.id}`} building={building} />)}

            {buildings.length>0 && mode==='scrolling' && buildings.map((building)=><BuildingPortfolioScrolling key={`building-table-${building.id}`} building={building} />)}
          </div>
        </div>
      </Section>}
    </>
  );
}

BuildingsPortfolio.getLayout = function getLayout(page) {
  return (
    <MainLayout>
      {page}
    </MainLayout>
  )
}

BuildingsPortfolio.getSEO = function getSEO() {
  return {
    title: "Portfólio nehnuteľností",
  }
}
